import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react';
import { Select } from '@mui/material';
import LoadingProgressStore from '../../store/LoadingProgressStore';
import LeadStore from '../../store/LeadStore';
import { toJS } from 'mobx';
import { People } from '@mui/icons-material';

const CustomSelect = styled(Select)({
  '& fieldset': {
    borderColor: '#F07B0E !important',
  },
  '& .MuiSelect-select': {
    fontSize: '14px',
    fontWeight: '600',
  },
});

const CustomDiv = styled('div')({
  '& .MuiInputBase-root': {
    height: '34px !important',
  },
});

export const PipelinesMenu = observer(({ defaultPipeline, handleSelectedPipelineChanged }) => {
  const [selectedPipeline, setSelectedPipeline] = useState('');
  const [pipelines, setPipelines] = useState([]);

  useEffect(() => {
    LeadStore.getPipelines();
  }, []);

  useEffect(() => {
    LeadStore.newPipelineSuccess && LeadStore.getPipelines();
  }, [LeadStore.newPipelineSuccess]);

  useEffect(() => {
    const selectedPipelineObj =
      selectedPipeline === null || selectedPipeline === ''
        ? null
        : pipelines.find((item) => item.id.toString() === selectedPipeline.toString());
    handleSelectedPipelineChanged(selectedPipelineObj);
  }, [selectedPipeline]);

  useEffect(() => {
    const pipelineLocal = [...toJS(LeadStore.pipelines)];
    if (defaultPipeline) {
      setSelectedPipeline(defaultPipeline?.id || defaultPipeline);
    } else {
      pipelineLocal.length && setSelectedPipeline(pipelineLocal[0].id);
    }
    setPipelines(pipelineLocal);
    LoadingProgressStore.toggleIsLoading(false);
  }, [LeadStore.pipelines]);

  const handlePipelineChange = (e) => {
    setSelectedPipeline(parseInt(e.target?.value));
  };

  return (
    <CustomDiv id="pipelines-menu">
      <CustomSelect
        value={selectedPipeline}
        onChange={handlePipelineChange}
        inputProps={{ 'aria-label': 'Without label' }}
        size="small"
        displayEmpty
      >
        {pipelines.map((item) => {
          return (
            <MenuItem
              key={item.id}
              value={item.id}
              sx={{
                backgroundColor:
                  selectedPipeline.toString() === item.id.toString() ? '#f07b0ed6 !important' : 'inherit',
                color: selectedPipeline.toString() === item.id.toString() ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: '#f07b0e38 !important',
                },
              }}
            >
              {item.name}
            </MenuItem>
          );
        })}
      </CustomSelect>
    </CustomDiv>
  );
});
